export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M21 21v-2H3v2zM3 16l4-4-4-4zm18 1v-2H11v2zM3 5h18V3H3zm18 4V7H11v2zm0 4v-2H11v2z\"/>"
};